import "@/App.css";
import Navbar from "./components/landing/Navbar";
import HeroSection from "./components/landing/HeroSection";
import StatsBar from "./components/landing/StatsBar";
import AboutSection from "./components/landing/AboutSection";
import BenefitsSection from "./components/landing/BenefitsSection";
import ProcessSection from "./components/landing/ProcessSection";
import WhyChooseSection from "./components/landing/WhyChooseSection";
import TestimonialsSection from "./components/landing/TestimonialsSection";
import FAQSection from "./components/landing/FAQSection";
import CTAFooter from "./components/landing/CTAFooter";
import Footer from "./components/landing/Footer";
import VapiVoiceButton from "./components/landing/VapiVoiceButton";

function App() {
  return (
    <div className="min-h-screen bg-white" data-testid="app-root">
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutSection />
        <BenefitsSection />
        <ProcessSection />
        <WhyChooseSection />
        <TestimonialsSection />
        <FAQSection />
        <CTAFooter />
      </main>
      <Footer />
      <VapiVoiceButton />
    </div>
  );
}

export default App;
